{
    "COMPANIES":{
        "COMPANY": "Compañía"
    }
}